/**
 * useFeaturedContent Hook
 * React Query hooks for featured ritualist, highlighted ritualists,
 * featured community rituals, and carousel communities
 */

import { useQuery } from "@tanstack/react-query"
import * as connectService from "../services/connect.service"

export function useFeaturedRitualist() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["connect-featured-ritualist"],
    queryFn: () => connectService.getFeaturedRitualist(),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  })

  return {
    ritualist: data ?? null,
    isLoading,
    error,
  }
}

export function useHighlightedRitualists(limit?: number) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["connect-highlighted-ritualists", limit],
    queryFn: () => connectService.getHighlightedRitualists(limit),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })

  return {
    ritualists: data ?? [],
    isLoading,
    error,
  }
}

export function useFeaturedCommunityRituals(limit?: number) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["connect-featured-community-rituals", limit],
    queryFn: () => connectService.getFeaturedCommunityRituals(limit),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })

  return {
    rituals: data ?? [],
    isLoading,
    error,
  }
}

export function useCarouselCommunities(limit?: number) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["connect-carousel", limit],
    queryFn: () => connectService.getCarouselCommunities(limit),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })

  return {
    communities: data ?? [],
    isLoading,
    error,
  }
}
